module.exports = __webpack_public_path__ + "static/sommer-04-a1c51602a47edac8782a005c55522bee.jpg";